// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"16":"css/admin_app","364":"css/app"}[chunkId] + ".css";
};